
import { Component, Prop, Vue } from "vue-property-decorator";
import tigermaster from "fdtigermaster-client-sdk";

type ItemStatus = "loading" | "ready" | "error";

@Component
export default class ServiceL3 extends Vue {
  @Prop() private item3!: string;

  //data
  workingCategory = {
    name: ''
  };
  itemStatus: ItemStatus = "loading";

  //hook
  created(): void {
    this.getIdInfo();
  }

  //methods
  async getIdInfo(): Promise<void> {
    this.itemStatus = "loading";

    try {
      const res = await tigermaster.database
        .query("working_category")
        .where("working_category.id", "=", this.item3)
        .get();
      const workingCategory = res.data[0];

      if (!workingCategory) {
        this.itemStatus = "error";
        return;
      }

      this.workingCategory = workingCategory;
      this.itemStatus = "ready";
    } catch (error) {
      console.error(`Failed to load service item ${this.item3}.`, error);
      this.itemStatus = "error";
    }
  }
  selectL3(): void {
    this.$emit("sendWorkingCategoryData", this.workingCategory);
  }
}
